<template>
    <div>
        <div class="jquery-ui-scope view bpms-Message"></div>
        <div></div>
    </div>
</template>
<script type="text/javascript">
    import loading from '../widgets/loading/loading.vue';
    export default {
        data() {
            return {
            }
        },
        methods: {

        },
        mounted() {
            console.log(this.$route.params.messageId);

            const view = $(this.$el).children(':nth-child(1)');
            const params1 = {
                element: view,
                messageId: this.$route.params.messageId
            };

            vm.MessageForm.activate(params1);
            debugger;
            if (this.$route.params.isReceiveMessage === "true") {
                var sendMessageHtml = "Views/ReplyMessage.html";
                const send = $(this.$el).children(':nth-child(2)');
                const params2 = {
                    element: send,
                    messageId: this.$route.params.messageId
                };
                if (payload.sendMessagePermission)
                    vm.sendMessage.activate(params2, sendMessageHtml);

                this.$root.$emit('ReloadMessageCount');

            }
        },
        components: {
            loading
        }
    }
</script>
